import FlexColumn from './FlexColumn';
import H5 from './H5';

const TableEmptyText = ({ children }) => {
    return (
        <FlexColumn justify="center" align="center" style={{ padding: 30, textAlign: 'center' }}>
            <H5>{children}</H5>
        </FlexColumn>
    );
};

export default TableEmptyText;
